// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cqzFJ","clicked":"styles_clicked__ObLfY"};